import React from 'react';
import styled from 'styled-components';

const BigCheck = () => <Span>✓</Span>;

const Span = styled.span`
  display: block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  margin: 5px auto 0;
  border-radius: 100%;
  background-color: #34a952;
  color: #fff;
  font-size: 28px;
  text-align: center;
`;

export default BigCheck;
